import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import '../../../modules/companies/register-panels'
import { RetentionPipelinePage } from '../../../modules/retention/retention-pipeline-page'
import { PANEL_TYPES } from '../../../shell/panel-state'

const renewalSearchSchema = z.object({
  q: z.string().optional(),
  view: z.enum(['table', 'board']).optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  filter: FilterExprSchema.optional(),
  quick: FilterExprSchema.optional(),
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
  panelMode: z.enum(['create']).optional(),
})

/** `/retention/renewals` - upcoming subscription renewals (subnav under Retention). */
export const Route = createFileRoute('/_authed/retention/renewals')({
  validateSearch: renewalSearchSchema,
  component: RenewalsRoute,
})

function RenewalsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <RetentionPipelinePage
      mode="renewals"
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => ({ ...prev, ...patch })) as never,
          replace: true,
        })
      }
    />
  )
}
